import { render, staticRenderFns } from "./FormValidation.vue?vue&type=template&id=18919c8d&scoped=true"
import script from "./FormValidation.vue?vue&type=script&lang=js"
export * from "./FormValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18919c8d",
  null
  
)

export default component.exports